var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row"},[_c('EmailVerification')],1),_c('div',{staticClass:"row"},[_c('PhoneVerification')],1),_c('div',{staticClass:"row"},[_c('ReleasePhoneLock')],1),_c('div',{staticClass:"row"},[_c('AccountVerification')],1),_c('div',{staticClass:"row"},[_c('VerificationStatus')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }